import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import classNames from "classnames";
import styles from "../styles/news-widget.module.scss";

export class NewsItemDataStructureProps extends BaseProps {
  itemMetaData: Boolean;
}

export const NewsItemDataStructure = ({
                                        itemMetaData,
                                        children,
                                      }: NewsItemDataStructureProps) => {

  const {position} = itemMetaData;

  return (
    <div itemProp="itemListElement" itemScope itemType={"https://schema.org/ListItem"}
         className={classNames(styles.news_container)}>
      <meta itemProp="position" content={position}/>
      {children}
    </div>
  )
};
